import { EnterpriseLearnerInsights_MetricTimeFrame as MetricTimeFrame } from '__generated__/graphql-types';

export const convertMetricTimeFrameToInt = (timeframe: MetricTimeFrame) => {
  return (
    {
      [MetricTimeFrame.ThirtyDays]: 30,
      [MetricTimeFrame.SixtyDays]: 60,
      [MetricTimeFrame.NinetyDays]: 90,
    }[timeframe] ?? 0
  );
};
